import React, { useEffect, useState } from 'react';
import { ShieldAlert } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import {
  isStorageSafeMode,
  getStorageSafeModeReason,
  STORAGE_SAFE_MODE_CHANGED,
  disableStorageSafeMode
} from '../infrastructure/storage/storageSafeMode';
import '../styles/components/system-banners.css';

const StorageSafeModeBanner = () => {
  const { t } = useLanguage();
  const ts = (key) => t(`storageSafeModeBanner.${key}`);
  const [active, setActive] = useState(() => isStorageSafeMode());
  const [reason, setReason] = useState(() => getStorageSafeModeReason());

  useEffect(() => {
    const sync = () => {
      setActive(isStorageSafeMode());
      setReason(getStorageSafeModeReason());
    };
    window.addEventListener(STORAGE_SAFE_MODE_CHANGED, sync);
    return () => window.removeEventListener(STORAGE_SAFE_MODE_CHANGED, sync);
  }, []);

  if (!active) return null;

  const handleDismissDev =
    process.env.NODE_ENV === 'development'
      ? () => {
          disableStorageSafeMode();
        }
      : undefined;

  return (
    <div className="storage-safe-mode-banner" role="status">
      <div className="storage-safe-mode-banner__inner">
        <ShieldAlert size={18} aria-hidden />
        <span>{ts('label')}</span>
        {reason && process.env.NODE_ENV === 'development' ? (
          <span className="storage-safe-mode-banner__reason">({reason})</span>
        ) : null}
        {handleDismissDev ? (
          <button type="button" className="storage-safe-mode-banner__dismiss" onClick={handleDismissDev}>
            {ts('dismissDev')}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default StorageSafeModeBanner;
